module.exports = __webpack_public_path__ + "static/media/diets.f66aa70a.svg";